/** @format */
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import NavBar from "../../Navbar/Navbar";
import { useImportLogic } from "./ImportLogic";
import {
  StepBar,
  LoadingModal,
  StepError,
  Step0Model,
  Step1Client,
  Step2Instance,
  Step3FinalCustomer,
  Step4Documents,
  Step5Validation,
  Step6Success,
  JSONEditorModal,
  FillAllJSONModal,
} from "./ImportComponent";
import "./Import.css";

export default function Import() {
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  // Utilisation de la logique d'importation personnalisée
  const { state, handlers, computed } = useImportLogic(fileInputRef);

  const { step, loading, error, role, showJSONEditor, showFillAllModal } =
    state;
  const { t, finalRoute, getSupportedFileTypes } = computed;

  // Fonction pour rendre le composant de l'étape actuelle
  const renderStep = () => {
    switch (step) {
      case -1:
        return (
          <StepError
            error={error}
            t={t}
            setStep={handlers.setStep}
            finalRoute={finalRoute}
            navigate={navigate}
          />
        );
      case 0:
        return (
          <Step0Model state={state} handlers={handlers} computed={computed} />
        );
      case 1:
        return role === "superadmin" ? (
          <Step1Client state={state} handlers={handlers} computed={computed} />
        ) : null;
      case 2:
        return (
          <Step2Instance
            state={state}
            handlers={handlers}
            computed={computed}
          />
        );
      case 3:
        return (
          <Step3FinalCustomer
            state={state}
            handlers={handlers}
            computed={computed}
          />
        );
      case 4:
        return (
          <Step4Documents
            state={state}
            handlers={handlers}
            computed={computed}
          />
        );
      case 5:
        return (
          <Step5Validation
            state={state}
            handlers={handlers}
            computed={computed}
          />
        );
      case 6:
        return (
          <Step6Success
            state={state}
            computed={computed}
            navigate={navigate}
            handlers={handlers}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <NavBar />
      <div
        style={{
          backgroundColor: "#f2f0f0",
          padding: "20px",
          minHeight: "95vh",
        }}
      >
        <StepBar step={step} role={role} t={t} />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minHeight: "400px",
          }}
        >
          <LoadingModal loading={loading} t={t} />

          {!loading && renderStep()}
        </div>

        <div style={{ backgroundColor: "#f2f0f0", padding: "20px" }}>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handlers.handleFileUpload}
            multiple
            style={{ display: "none" }}
            accept={getSupportedFileTypes()
              .map((type) => "." + type)
              .join(",")}
          />
        </div>
      </div>

      {showJSONEditor && (
        <JSONEditorModal
          state={state}
          handlers={handlers}
          computed={computed}
        />
      )}
      {showFillAllModal && (
        <FillAllJSONModal
          state={state}
          handlers={handlers}
          computed={computed}
        />
      )}
    </>
  );
}
